// @mui
import {
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
  Table,
  TableHead,
} from "@mui/material";

// ----------------------------------------------------------------------
const getEventName = (relatedType) => {
  switch (relatedType) {
    case 0:
      return "Add on Sale";
    case 1:
      return "Sell";
    case 2:
      return "Buy";
    case 3:
      return "Remove from Sale";
    default:
      return "?";
  }
};

export default function CardHistoryTable(props) {
  return (
    <>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Card ID</TableCell>
              <TableCell>From User</TableCell>
              <TableCell>To User</TableCell>
              <TableCell>Event</TableCell>
              <TableCell>Reference</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props?.history?.map((row, index) => (
              <TableRow
                key={index}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                }}
              >
                <TableCell component="th" scope="row">
                  {row.cardId}
                </TableCell>
                <TableCell component="th" scope="row">
                  {row.fromUserId}
                </TableCell>
                <TableCell component="th" scope="row">
                  {row.toUserId}
                </TableCell>
                <TableCell component="th" scope="row">
                  {getEventName(row.event)}
                </TableCell>
                <TableCell component="th" scope="row">
                  {row.reference}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
